
import { useState, useEffect } from 'react';
import { toast } from '@/components/ui/use-toast';
import { getProfiles } from '@/services/profileService';
import { getOrganizations } from '@/services/organizationService';
import { Profile } from '@/types/auth';
import { Organization } from '@/types/flight';

// Extended profile type that includes organization data
export type ProfileWithOrganization = Profile & {
  organization?: Organization;
};

export function useUserData() {
  const [profiles, setProfiles] = useState<ProfileWithOrganization[]>([]);
  const [organizations, setOrganizations] = useState<Organization[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      setLoading(true);
      const [profilesData, orgsData] = await Promise.all([
        getProfiles(),
        getOrganizations()
      ]);
      setProfiles(profilesData as ProfileWithOrganization[]);
      setOrganizations(orgsData);
    } catch (error: any) {
      toast({
        variant: "destructive",
        title: "Error loading data",
        description: error.message || "Failed to load users and organizations.",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return {
    profiles,
    organizations,
    loading,
    fetchData,
  };
}
